import { render, staticRenderFns } from "./BrandCentre.vue?vue&type=template&id=0d26f37f&scoped=true"
import script from "./BrandCentre.vue?vue&type=script&lang=js"
export * from "./BrandCentre.vue?vue&type=script&lang=js"
import style0 from "./BrandCentre.vue?vue&type=style&index=0&id=0d26f37f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d26f37f",
  null
  
)

export default component.exports